import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { every, some, map } from 'lodash';

import SalesTableHeader from './sales_table_header';
import SaleRowContainer from 'bundles/comps/index/sale/sale_row_container';
import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import SelectionDetails from 'components/selection_details';

import {
  resetSelectedSales,
  resetSelectedSalesOnCurrentPage,
  toggleSelectAllSales,
  toggleSelectAllSalesOnCurrentPage
} from '../store/actions/select_list';

export class SalesTable extends React.Component {
  static propTypes = {
    allSaleIds: PropTypes.array.isRequired,
    resetSelection: PropTypes.func.isRequired,
    resetSelectionOnCurrentPage: PropTypes.func.isRequired,
    sales: PropTypes.array.isRequired,
    selectedSaleIds: PropTypes.array.isRequired,
    toggleSelectAll: PropTypes.func.isRequired,
    toggleSelectAllOnCurrentPage: PropTypes.func.isRequired
  };

  allSelected() {
    return every(this.props.sales, sale => this.isSelected(sale.id)) && this.props.sales.length > 0;
  }

  someSelected() {
    return some(this.props.sales, sale => this.isSelected(sale.id)) && this.props.sales.length > 0;
  }

  isSelected(saleId) {
    return this.props.selectedSaleIds.indexOf(saleId) > -1;
  }

  render() {
    const { resetSelectionOnCurrentPage, toggleSelectAllOnCurrentPage } = this.props;

    return (
      <div className="table-container border-top-0 border-start-0 border-end-0 h-100">
        <SelectableRecordTable
          columnHeaders={<SalesTableHeader />}
          selectAllChecked={this.allSelected()}
          selectNoneVisible={this.someSelected()}
          onResetSelection={resetSelectionOnCurrentPage}
          onSelectAllToggle={toggleSelectAllOnCurrentPage}
        >
          <SelectionDetails
            forTable
            label="sale"
            selectedCount={this.props.selectedSaleIds.length}
            totalCount={this.props.allSaleIds.length}
            onClearSelection={this.props.resetSelection}
            onSelectAll={this.props.toggleSelectAll}
          />
          {this.renderSales()}
        </SelectableRecordTable>
      </div>
    );
  }

  renderSales() {
    const { sales } = this.props;
    return map(sales, sale => (
      <SaleRowContainer
        key={sale.id}
        sale={sale}
        selected={this.isSelected(sale.id)}
      />
    ));
  }
}

const mapStateToProps = state => ({
  allSaleIds: state.search.meta.compIds,
  sales: state.search.sales,
  selectedSaleIds: state.selectList.selectedSaleIds,
});

const mapDispatchToProps = {
  resetSelection: resetSelectedSales,
  resetSelectionOnCurrentPage: resetSelectedSalesOnCurrentPage,
  toggleSelectAll: toggleSelectAllSales,
  toggleSelectAllOnCurrentPage: toggleSelectAllSalesOnCurrentPage
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesTable);
